import { useMutation } from "react-query"
import api from "../client"
import { AddressDetailResponseData, CreateAddressPayload } from "../types/address"

const postData = async (id: string | undefined, payload: CreateAddressPayload) => {
    const { data } = await api.put<AddressDetailResponseData>(
        `/address/${id}`,
        payload
    )
    return data
}

export const useUpdateAddress = (id: string | undefined) => {
    return useMutation((payload: CreateAddressPayload) => {
        return postData(id, payload)
    })
}
